import React from "react";
import "react-datepicker/dist/react-datepicker.css";

import { Routes, Route, Navigate } from "react-router-dom";
import Login from "./pages/auth/Login";
import DefaultLayout from "./components/layout/DefaultLayout";
import Dashboard from "./pages/dashboard/Dashboard";
import Users from "./pages/user/Users";
import Error404 from "./components/Error404";
import Error500 from "./components/Error500";
import AuthProtect from "./protect/AuthProtect";
import UserDomain from "./pages/userdomain/UserDomain";
import Profile from "./pages/profile/Profile";
import Revenue from "./pages/revenue/Revenue";
import AddDomain from "./pages/domain/AddDomain";
import AddEditRevenue from "./pages/revenue/AddEditRevenue";
import Transection from "./pages/transection/transection";
import Reconcilations from "./pages/reconcilations/Reconcilations";
import Reconcilationsview from "./pages/reconcilations/Reconcilationsview";
import Domainrequest from "./pages/domainrequest/Domainrequest";

const App = () => {
  return (
    <Routes>
      {/* Public Routes */}
      <Route element={<Error404 />} path={`/404`} />
      <Route element={<Error500 />} path={`/500`} />

      <Route path="/admin/login" element={<Login />} />

      {/* Default fallback route */}
      <Route path="*" element={<Navigate to="/404" />} />

      {/* Protected Routes */}
      <Route element={<AuthProtect />}>
        <Route element={<DefaultLayout />}>
          <Route path="/" element={<Navigate to="/admin/dashboard" />} />
          <Route path="/admin/dashboard" element={<Dashboard />} />
          <Route path="/admin/users" element={<Users />} />
          <Route path="/admin/profile" element={<Profile />} />

          <Route path="/admin/users/domains" element={<UserDomain />} />
          <Route path="/admin/users/domains/add" element={<AddDomain />} />

          <Route
            path="/admin/users/domains/:domainId/:userId/revenue"
            element={<Revenue />}
          />

          <Route
            path="/admin/users/domains/:domainId/:userId/revenue/add"
            element={<AddEditRevenue />}
          />

          <Route path="/admin/users/transection" element={<Transection />} />
          <Route path="/admin/users/reconcilations" element={<Reconcilations />} />
          <Route path="/Reconcilationsview/view/:id" element={<Reconcilationsview />} />
          <Route path="/admin/domain-request" element={<Domainrequest />} />
        </Route>
      </Route>
    </Routes>
  );
};

export default App;
